import { api } from "@/lib/api";

/**
 * Lightweight analytics stub. Logs to console and fires a backend
 * /events endpoint for later wiring to a real provider.
 */
export function track(name, props = {}) {
    try {
        // eslint-disable-next-line no-console
        console.log(`[analytics] ${name}`, props);
        api.post("/events", { name, props }).catch(() => {});
    } catch (_) {
        // swallow — analytics must never break the app
    }
}
